import { Notice } from "@bokio/designsystem/components/Notice/Notice";
import Markdown from "@bokio/elements/Markdown/Markdown";
import { GeneralLangFactory } from "@bokio/lang";
import { getRoute } from "@bokio/shared/route";
import { formatMessage } from "@bokio/shared/utils/format";

import type { FC } from "react";

import * as styles from "./failedPaymentTopBar.scss";

interface FailedPaymentTopBarProps {
	company: string;
}

export const FailedPaymentTopBar: FC<FailedPaymentTopBarProps> = props => {
	const lang = GeneralLangFactory();
	return (
		<Notice color="error" margin={[]} className={styles.topBarNotice} hasIcon={false}>
			<div className={styles.topBarContent}>
				<span className={styles.topBarSymbol}>!</span>
				<Markdown
					markdownContent={formatMessage(
						lang.FailedPayment_Bar_Text,
						"bokio:" + getRoute("billing", { company: props.company }, { tab: "receipts" }),
					)}
					deprecatedOptoutFromTypographicElements
				/>
			</div>
		</Notice>
	);
};
